var STOPS = /*#__PURE__*/function (STOPS) {
  STOPS["ZERO"] = "0";
  STOPS["ONE"] = "1";
  STOPS["TWO"] = "2";
  STOPS["THREE"] = "3";
  return STOPS;
}(STOPS || {});
export default STOPS;